import type { ReactNode } from 'react';
import { NJHeading } from '@engie-group/fluid-design-system-react';
import { UMIcon, UMR } from '../../urbanmap/_components';

export function EmptyState({ icon, title, children }: { icon: string; title: string; children?: ReactNode }) {
  return (
    <div className="pav-empty">
      <UMIcon name={icon} size={40} color={UMR.textSecondary} />
      <NJHeading as="h3" scale="sm">{title}</NJHeading>
      {children}
    </div>
  );
}
